var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.92487 5.92487 1 12 1H28C34.0751 1 39 5.92487 39 12V28C39 34.0751 34.0751 39 28 39H12C5.92487 39 1 34.0751 1 28V12Z",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0417 8.69922H8.43909V31.3018H31.0417V8.69922Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7404 28.4764C24.4215 28.4764 28.2164 24.6815 28.2164 20.0004C28.2164 15.3192 24.4215 11.5244 19.7404 11.5244C15.0592 11.5244 11.2644 15.3192 11.2644 20.0004C11.2644 24.6815 15.0592 28.4764 19.7404 28.4764ZM19.7404 25.6508C22.8612 25.6508 25.391 23.121 25.391 20.0002C25.391 16.8794 22.8612 14.3495 19.7404 14.3495C16.6196 14.3495 14.0897 16.8794 14.0897 20.0002C14.0897 23.121 16.6196 25.6508 19.7404 25.6508Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6291 11.5245C30.4093 11.5245 31.0417 10.8921 31.0417 10.1119C31.0417 9.33169 30.4093 8.69922 29.6291 8.69922C28.8489 8.69922 28.2164 9.33169 28.2164 10.1119C28.2164 10.8921 28.8489 11.5245 29.6291 11.5245Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.d0a68579736c4b701df531718f86ee73.svg";
export { ForwardRef as ReactComponent };